import style from "./DynamicTooltip.module.scss";
import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

export const DynamicTooltip = ({
  children,
  targetRef,
  isTooltipVisible,
  styles = {}
}) => {
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const tooltipRef = useRef(null);

  useEffect(() => {
    if (targetRef.current) {
      const rect = targetRef.current.getBoundingClientRect();
      const tooltipRect = tooltipRef.current.getBoundingClientRect();

      setPosition({
        top: rect.top + window.scrollY - tooltipRect.height - 10,
        left: rect.left + rect.width / 2 - tooltipRect.width / 2
      });
    }
  }, [targetRef, isTooltipVisible]);

  return createPortal(
    <div
      ref={tooltipRef}
      className={`${style.dynamicTooltip} ${
        isTooltipVisible ? style.visible : ""
      }`}
      style={{
        ...styles,
        position: "absolute",
        top: `${position.top}px`,
        left: `${position.left}px`,
        transform: `translate(0, 0)`
      }}
    >
      {children}
    </div>,
    document.body
  );
};
